import React, { useState } from 'react';
import { HiOutlineArrowRight, HiOutlineCheckCircle, HiOutlineMapPin, HiOutlineEnvelope, HiOutlinePhone } from 'react-icons/hi2';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    firstName: '', lastName: '', email: '', company: '', role: '', interest: '', message: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you! We will get back to you within 24 hours.');
  };

  return (
    <>
      <section className="page-hero">
        <div className="container">
          <div className="section-label">Get Started</div>
          <h1>Contact Us</h1>
          <p>Ready to operationalize AI? Let's start with a conversation about your goals.</p>
        </div>
      </section>

      <section className="section section-dark">
        <div className="container">
          <div className="contact-grid">
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label>First Name</label>
                  <input type="text" name="firstName" placeholder="John" value={formData.firstName} onChange={handleChange} required />
                </div>
                <div className="form-group">
                  <label>Last Name</label>
                  <input type="text" name="lastName" placeholder="Doe" value={formData.lastName} onChange={handleChange} required />
                </div>
              </div>
              <div className="form-group">
                <label>Work Email</label>
                <input type="email" name="email" placeholder="john@company.com" value={formData.email} onChange={handleChange} required />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Company</label>
                  <input type="text" name="company" placeholder="Company Name" value={formData.company} onChange={handleChange} />
                </div>
                <div className="form-group">
                  <label>Role</label>
                  <input type="text" name="role" placeholder="CTO, VP Engineering, etc." value={formData.role} onChange={handleChange} />
                </div>
              </div>
              <div className="form-group">
                <label>Area of Interest</label>
                <select name="interest" value={formData.interest} onChange={handleChange}>
                  <option value="">Select an area</option>
                  <option value="ai-strategy">AI Strategy & Readiness</option>
                  <option value="data-platform">Data Platform Modernization</option>
                  <option value="genai-rag">GenAI / RAG Applications</option>
                  <option value="llm-eval">LLM Evaluation</option>
                  <option value="mlops">MLOps & Governance</option>
                  <option value="other">Other</option>
                </select>
              </div>
              <div className="form-group">
                <label>Message</label>
                <textarea name="message" placeholder="Tell us about your project and goals..." value={formData.message} onChange={handleChange}></textarea>
              </div>
              <button type="submit" className="btn-primary" style={{ width: '100%', justifyContent: 'center' }}>
                Book a Discovery Call <HiOutlineArrowRight />
              </button>
            </form>

            <div>
              <div className="contact-info-card">
                <div style={{ fontSize: 28, marginBottom: 12, color: 'var(--violet-light)' }}>
                  <HiOutlineMapPin />
                </div>
                <h3>Office</h3>
                <p>123 Innovation Drive, Suite 400<br />San Francisco, CA 94105</p>
              </div>
              <div className="contact-info-card">
                <div style={{ fontSize: 28, marginBottom: 12, color: 'var(--violet-light)' }}>
                  <HiOutlineEnvelope />
                </div>
                <h3>Email</h3>
                <p>hello@disensystems.com<br />sales@disensystems.com</p>
              </div>
              <div className="contact-info-card">
                <div style={{ fontSize: 28, marginBottom: 12, color: 'var(--violet-light)' }}>
                  <HiOutlinePhone />
                </div>
                <h3>Phone</h3>
                <p>+1 (555) 123-4567</p>
              </div>
              <div className="contact-info-card" style={{ background: 'rgba(139,92,246,0.08)', borderColor: 'var(--border-color)' }}>
                <h3 style={{ color: 'var(--violet-light)' }}>What to expect</h3>
                <div style={{ marginTop: 16, display: 'flex', flexDirection: 'column', gap: 12 }}>
                  {[
                    '30-minute discovery call',
                    'Understand your AI goals & challenges',
                    'Custom solution recommendations',
                    'No commitment required',
                  ].map((item, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 14, color: 'var(--text-secondary)' }}>
                      <HiOutlineCheckCircle style={{ color: 'var(--amber)', fontSize: 18, flexShrink: 0 }} /> {item}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactPage;
